'use strict'

import game from './game'
import roulette from './roulette'

export default { game, roulette }



// WEBPACK FOOTER //
// ./resources/assets/js/roulette/api/index.js